import { state, mutations } from './mutations';
import * as getters from './getter';

export default {
  name: 'statistics',
  state,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/modules/Statistics/_store/index.js